export default __webpack_public_path__ + "static/media/640_store05-es-web.40562cfa.png";